import { ICliJob } from 'cliOld/types';
import { mapRecordsFromServer } from 'coreOld/mappers';
import { partfinitiClient } from 'coreOld/services';
import { GetManyResponse, IRequestPayload } from 'coreOld/types';
import {
  getFormData,
  getQueryString,
  objectKeysCamelToSnakeCase,
  objectKeysSnakeCaseToCamelCase,
} from 'coreOld/utils';
import { IUom, IUomForm } from 'partsOld/types';

export const getMany = async (
  requestPayload?: IRequestPayload
): Promise<GetManyResponse<IUomForm>> => {
  const { data } = await partfinitiClient.get(
    `/uom/part-uom-conversion-list/conversions?${getQueryString(
      objectKeysCamelToSnakeCase(requestPayload)
    )}`
  );

  return mapRecordsFromServer<IUomForm>(data.data, data.recordsFiltered);
};

export const getManyBaseUoms = async (
  requestPayload?: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IUom>> => {
  const { data } = await partfinitiClient.get(
    `/parts/uom/autocomplete?${getQueryString(objectKeysCamelToSnakeCase(requestPayload))}`,
    signal
  );

  return mapRecordsFromServer<IUom>(data.uoms, data.total_count);
};

export const editUom = async () => {
  /* eslint-disable-next-line */
  //TODO - call to BE
};

export const removeUomConversion = async (data) => {
  return partfinitiClient.post('/uom/part-uom-conversion-edit/remove', getFormData(data));
};

export const upsertUomConversion = async (data) => {
  const formData = getFormData({
    part_uom_conversion: objectKeysCamelToSnakeCase(data),
  });

  return partfinitiClient.post('/uom/part-uom-conversion-edit/save', formData, {
    'content-Type': 'multipart/form-data',
  });
};

export const exportUomConversions = async (data): Promise<ICliJob> => {
  const dataToSend = getFormData({
    options: objectKeysCamelToSnakeCase(data),
  });

  const { data: record } = await partfinitiClient.post(
    '/corporate_v2/part/start-generating-uom-conversion-export-file',
    dataToSend
  );

  return objectKeysSnakeCaseToCamelCase(record.cli_job);
};
